import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function RiskDisclosure() {
  return (
    <div className="min-h-screen bg-background pt-32 pb-16">
      <Helmet>
        <title>Risk Disclosure | Synthetic Trading Hub</title>
        <meta name="description" content="Understand the risks involved in synthetic trading and online financial markets." />
        <meta name="keywords" content="synthetic trading, synthetic indices trading, deriv trading guide, crash boom trading, trading for beginners, online trading platform" />
        <meta property="og:title" content="Risk Disclosure | Synthetic Trading Hub" />
        <meta property="og:description" content="Understand the risks involved in synthetic trading and online financial markets." />
        <meta property="og:url" content="https://synthetictradinghub.com/risk-disclosure" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Risk Disclosure | Synthetic Trading Hub" />
        <meta name="twitter:description" content="Understand the risks involved in synthetic trading and online financial markets." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1569025743873-ea3a9ade89f9" />
        <link rel="canonical" href="https://synthetictradinghub.com/risk-disclosure" />
      </Helmet>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">Risk Disclosure</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString('en-GB')}</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <section className="p-4 bg-amber-50 border border-amber-200 rounded-lg">
            <p className="font-semibold text-gray-900">
              Trading derivatives carries a high level of risk to your capital. You should only trade with money
              you can afford to lose. Trading derivatives may not be suitable for all investors.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">About this site</h2>
            <p>
              This website is an affiliate landing page that promotes the Deriv trading platform. We are not the
              broker or platform operator. When you open an account or trade, you do so on the official Deriv
              platform at{' '}
              <a href="https://deriv.com" target="_blank" rel="noopener noreferrer" className="text-[#ff444f] hover:underline">deriv.com</a>,
              which has its own risk disclosures and terms. You should read those before trading.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">General risks</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>You may lose some or all of your invested capital.</li>
              <li>Leverage can amplify both gains and losses.</li>
              <li>Past performance is not indicative of future results.</li>
              <li>Markets can be volatile and illiquid.</li>
              <li>Regulatory and tax treatment may vary by jurisdiction.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">Your responsibility</h2>
            <p>
              You are responsible for understanding the risks involved in trading and for ensuring that any
              trading or investment decisions are appropriate for your circumstances. You should seek independent
              financial or legal advice if necessary.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link to="/" className="text-[#ff444f] font-semibold hover:underline">← Back to home</Link>
        </div>
      </div>
    </div>
  );
}
